import { connect } from 'react-redux';
import { ReduxModel } from 'core/models';

const mapStateToProps = (state: ReduxModel.IGlobalState) => ({
  reduxState: state,
});

export default () => connect(mapStateToProps);
